import { atom, selector } from 'recoil';
import {
  ModelArray,
  GetDetailModelDtoRx,
  GetModelReportDtoRx,
} from '@/sdk/data-contracts';

export const modelListRecoil = atom<ModelArray[]>({
  key: 'modelListRecoil',
  default: [],
});

export const modelDetailRecoil = atom<GetDetailModelDtoRx | null>({
  key: 'modelDetailRecoil',
  default: null,
});

export const modelReportRecoil = atom<GetModelReportDtoRx[]>({
  key: 'modelReportRecoil',
  default: [],
});
